import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConstructionHelmet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconConstructionHelmet"><Path d="M3 13.5C3 9.58134 5.50442 6.24762 9 5.01212V15H3V13.5Z" fill="currentColor"/><Path d="M21 15V13.5C21 9.58134 18.4956 6.24762 15 5.01212V15H21Z" fill="currentColor"/><Path d="M2 17C2 16.4477 2.44772 16 3 16H21C21.5523 16 22 16.4477 22 17V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V17Z" fill="currentColor"/><Path d="M10 5.5C10 4.67157 10.6716 4 11.5 4H12.5C13.3284 4 14 4.67157 14 5.5V15H10V5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConstructionHelmet;
